import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
	constructor(el) {
		this.el = el;

		const logosSlider = tns({
			container: this.el,
			responsive: {
				350: {
					items: 2
				},
				600: {
					items: 4
				},
				900: {
					items: 6
				}

			},
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			gutter: 20
		});

		return logosSlider;
		
	}
}

export default LogosSlider;